﻿$.extend(UserInfo.prototype, UserInfoBalanceData.prototype);

UserInfo.onLogin = UserInfo.onLogin || {};
UserInfo.onGetBalance = UserInfo.onGetBalance || {};
UserInfo.onLoginSucceed = UserInfo.onLoginSucceed || {};
UserInfo.onLoginFailed = UserInfo.onLoginFailed || [];
UserInfo.onLogout = UserInfo.onLogout || {};
UserInfo.onDataUpdated = UserInfo.onDataUpdated || {};
UserInfo.onNotLoggedIn = UserInfo.onNotLoggedIn || {};
UserInfo.onCommand = UserInfo.onCommand || {};
UserInfo.onMessage = UserInfo.onMessage || {};
UserInfo.onCaptcha = UserInfo.onCaptcha || {};
UserInfo.onUpdateBalance = UserInfo.onUpdateBalance || {};
UserInfo.onTwoStepLogin = UserInfo.onTwoStepLogin || {};
UserInfo.onTokenLogin = UserInfo.onTokenLogin || {};
UserInfo.onAcceptOddsChanged = UserInfo.onAcceptOddsChanged || {};
UserInfo.onLimitationsDataUpdated = UserInfo.onLimitationsDataUpdated || {};
UserInfo.onAfterLogout = UserInfo.onAfterLogout || {};
UserInfo.onJWTUpdated = UserInfo.onJWTUpdated || {};


UserInfo.executeLogin = false;
UserInfo.Tries = 0;
UserInfo.TaxProvider = UserInfo.TaxProvider || EmptyTaxProvider;
UserInfo.current = null;
UserInfo.selfExclusionCheckInterval = 900000;
UserInfo.OnTwoStepNativeLogin = [];
UserInfo.UpdateBalanceTreshhold = 2000;
UserInfo.CheckSessionInterval = 60000;


UserInfo.updateBalance = function (callback)
{
    UserInfo.updateExtSession(); // updates balance for seamless

    UserInfo.updateOpenBetsData();

    UserInfoPageMethods.getUserInfo(
        function (res)
        {
            var result = eval(res);

            if (result == "-1")
            {
                var isUserLoggedIn = UserInfo.current !== null;
                if (isUserLoggedIn)
                {
                    postNativeCallback(nativeCallbackKind.SessionExpired);
                }
                
                if (UserInfo.current) { UserInfo.showMessage($string("Login").SessionExpired); }
                UserInfo.logout();
            }
            else if (result == "-2")
            {
                if (UserInfo.current) { UserInfo.showMessage($string("Login").MultipleLogin); }
                UserInfo.logout();
            }
            else if (result == "-3")
            {
                if (UserInfo.current) { UserInfo.showMessage($string("Login").AccountRestricted); }
                UserInfo.logout();
            }
            else if (result == "-4")
            {
                if (UserInfo.current) { UserInfo.showMessage($string("Login").OneSessionAllowed); }
                UserInfo.logout();
            }
            else if (result == "-5")
            {
                if (UserInfo.current) { UserInfo.showMessage($string("Login").LockedUserAccount); }
                UserInfo.logout();
            }
            else if (result == "-1000")
            {
                underMaintence();
            }
            else
            {
                UserInfo.executeCommands(eval(result[4])); // evaluate because it's serialized as a string by the server
                UserInfo.updateData(result);

                if (callback && typeof callback === 'function')
                {
                    callback.call(this);
                }
            }
        },
        function ()
        {
            // don't force logout on balance error
            //UserInfo.logout();
        }
    );
}

function visibilityChange() {
    if (!(typeof InactivityLogoutMinutes !== "undefined" && InactivityLogoutMinutes > 0)) {
        return;
    }
    if (!document.hidden) {
        UserInfo.CheckSessionUpdater.start();
        UserInfo.checkSession();
        SetLastActivityTime();
    } else {
        UserInfo.CheckSessionUpdater.stop();
    }
}

document.addEventListener('visibilitychange', visibilityChange, false);

UserInfo.checkSession = function() {
    if (InactivityLogoutMinutes == 0) return;

    var time = getLastActivityTime();

    if ((new Date()).getTime() - getLastActivityTime() > InactivityLogoutMinutes * 60 * 1000) {
        if (UserInfo) {
          	if (UserInfo.current) { 
            	UserInfo.showMessage($string("Login").SessionExpired); 
            }
            UserInfo.logout(true);
        }
    }
}

UserInfo.updateExtSession = function ()
{
    if (!UserInfo.current) return;

    if (IsAPIDefined())
    {
        APIUser().refreshSession(
            function (res)
            {
                var log = new ESInfoLogger("UpdateSession");

                if (res.status.toLowerCase() == "failure")
                {
                    log.addInfo("RefreshSession response: " + JSON.stringify(res));
                    if (res.message) { UserInfo.showMessage("Error: " + res.message); }
                    UserInfo.logout();
                }
                else
                {   // Set balance for seamless:
                    if (res.balance && res.balance != "-1")
                    {
                        UserInfo.SeamlessCustomerBalance = res.balance;
                        if (UserInfo.current)
                        {   //update seamless balance
                            UserInfo.current.updateBalance(UserInfo.SeamlessCustomerBalance);
                            if (UserInfo.onUpdateBalance) { executeEvents(UserInfo.onUpdateBalance); }
                        }
                    }
                }

                log.end();
            }
        );
    }
}

UserInfo.setAcceptChangingOdds = function (acceptOdds)
{
    var val = parseInt(acceptOdds);
    if (!UserInfo.current || UserInfo.current.AcceptChangingOdds === val) return;

    UserInfo.current.AcceptChangingOdds = val ? val : AcceptChangingOddsModes.AcceptChangedOddsNever;

    executeEvents(UserInfo.onAcceptOddsChanged, this, UserInfo.current.AcceptChangingOdds);
}

UserInfo.prototype.dispatchIsPlacingBetsDisabledChanged = function (isPlacingBetsDisabled)
{
    if (this && this.EventsManager)
    {
        this.EventsManager.dispatchEvent('onIsPlacingBetsDisabledChanged', !!isPlacingBetsDisabled, true);
    }
};

UserInfo.tryObtainExternalLogin = function ()
{    
    if (UserInfo.current) return;
    
    if (IsAPIDefined())
    {
        APIUser().status(
            function (res)
            {
                var log = new ESInfoLogger("ExternalLogin");

                if (res.status.toLowerCase() == "error")
                {
                    log.addInfo("Status error message: " + res.message + ". Status response: " + JSON.stringify(res));
                    UserInfo.showMessage(res.message);
                    if (UserInfo.current) UserInfo.logout();
                    return;
                }

                if (res.status.toLowerCase() == "real")
                {
                    // Set balance for seamless:
                    if (res.balance && res.balance != "-1")
                    {
                        UserInfo.SeamlessCustomerBalance = res.balance;
                        if (UserInfo.current)
                        {   //update seamless balance
                            UserInfo.current.updateBalance(UserInfo.SeamlessCustomerBalance);
                            if (UserInfo.onUpdateBalance) { executeEvents(UserInfo.onUpdateBalance); }
                        }
                    }

                    if (UserInfo.current) return;

                    if (res.token)
                    {
                        setTimeout(function () { UserInfo.tokenLogin(res); }, 10);
                    }
                    else
                    {
                        // UserInfo.setBalanceCookies(0);
                        UserInfo.updateData(res);
                    }

                    return;
                }

                // we have different checks for "anon" and "error" status because 
                // we don't have an error message for "anon" status
                if (res.status.toLowerCase() == "anon")
                {
                    var hasUserName = UserInfo.current != null;
                    var statusResponse = "Status response: " + JSON.stringify(res);
                    var logMessage = hasUserName ? "Logout for " + UserInfo.current.userName + ". " + statusResponse : statusResponse;

                    log.addInfo(logMessage);
                    UserInfo.logout(true);
                }

                log.end();
            }
        );
    }
}

UserInfo.tokenLogin = function (loginResult)
{
    if (UserInfo.current) return;

    UserInfo.executeLogin = true;

    var token = loginResult.token;
    PageMethods.tokenLogin(token,
        function (res)
        {
            if (res == '[]')
            {
                var errorMsg = $string("Login").WrongUserNameOrPassword;
                UserInfo.showMessage(errorMsg);
                UserInfo.GTMLoginFailed(errorMsg);
                UserInfo.logout();
                return;
            }

            // Restrictions:
            var error = JSON.parse(res).Error;
            if (error && error.indexOf("restrictedCountry") != -1)
            {
                var country = error.split(':')[1];
                var errorMsg = $string("Login").LoginRestrictedPart1 + "\n\r" + $string("Login").LoginRestrictedPart2 + country + "\n\r" + $string("Login").LoginRestrictedPart3;
                UserInfo.showMessage(errorMsg);
                UserInfo.GTMLoginFailed(errorMsg);
                return;
            }
            if (error && error.indexOf("restrictedRegion") != -1)
            {
                var region = error.split(':')[1];
                var errorMsg = $string("Login").LoginRestrictedPart1 + "\n\r" + $string("Login").LoginRestrictedPart5 + region + "\n\r" + $string("Login").LoginRestrictedPart6;
                UserInfo.showMessage(errorMsg);
                UserInfo.GTMLoginFailed(errorMsg);
                return;
            }

            // UserInfo.setBalanceCookies(0);
            executeEvents(UserInfo.onTokenLogin, this, loginResult);

            var result = eval(res);
            UserInfo.updateData(result);
            UserInfo.GTMLoginSuccess();
        },
        function ()
        {
            UserInfo.GTMLoginFailed();
            UserInfo.logout();
        }
    );
}

UserInfo.prototype.getAdditionalCustomerData = function (balanceAvailableOnLogin, balanceConfig, creditLimit)
{
    var ref = this;
    function retry()
    {
        setTimeout(function()
          {
            ref.getAdditionalCustomerData(balanceAvailableOnLogin, balanceConfig, creditLimit);
          }, 5000);
    }

    if (ref.isBalancesinitiated())
    {
        // call guard: this is needed only once
        return;
    }

    if (balanceAvailableOnLogin)
    {
        executeEvents(UserInfo.onGetBalance);
    }
    else
    {
        UserInfo.updateOpenBetsData(true);
        UserInfoPageMethods.GetMyCurrentBalance(function (serverResponse) { //replace GetBalance with the newly created method in UserInfo.ashx
            if (!serverResponse)
            {
                retry();
                return;
            }

            var response = JSON.parse(serverResponse);
            if (response.Error)
            {
                retry();
                return;
            }
          
            ref.setBalanceConfigAndCreditLimit(balanceConfig, creditLimit);
            ref.updateBalanceData(response);
            ref.balanceCallExecuted = true;
            if (ref.isBalancesinitiated())
            {
                executeEvents(UserInfo.onGetBalance);
            }
        },
        function () {
            retry();
        });
    }
}

UserInfo.prototype.isBalancesinitiated = function ()
{
    return this.balanceCallExecuted && this.openBetsCallFinished;
}

UserInfo.updateData = function (result)
{
    if (result.length >= 32 && result[31])
    {
        JWT_TOKEN = result[31];
        
        StorageUtils.saveToStorage("JWT_TOKEN", JWT_TOKEN, sessionStorage);
    }

    if (!UserInfo.current)
    {
        UserInfo.current = new UserInfo(result);
        document.body.classList.add('loggedin');
        UserInfo.setAcceptChangingOdds(result[35]);
        UserInfo.current.platformJWT = result.platformJWT;
        executeEvents(UserInfo.onJWTUpdated);
        executeEvents(UserInfo.onLogin);
    }
    else
    {
        UserInfo.current.updateData(result);
        executeEvents(UserInfo.onDataUpdated, this, result);
    }

    // save UserInfo FreeBets in session storage
    UserInfo.saveFreeBetsState();

    UserInfo.executeLogin = false;
}
 
UserInfo.prototype.parseFreeBets = function (data)
{    
    return HashtableOf(data, BonusInfo, "BonusID");
}

UserInfo.prototype.setAdditionalBalances = function (data)
{
    if (data.length <= 18 || data[18] * 1 == BalanceConfig.NONE) return;

    var totalBalance = UserInfo.SeamlessCustomerBalance ? UserInfo.SeamlessCustomerBalance : data[3];
    var openBetsBalance = data[7] + data[11];
    var creditLimit = data[17] * 1;

    switch (data[18] * 1)
    {
        case BalanceConfig.WEEKLYBALANCE:
            this.WeeklyCashBalance = ((totalBalance + openBetsBalance) - creditLimit).toStringEx("#.00");
            break;
        case BalanceConfig.CASHBALANCE:
            this.CashBalance = ((totalBalance + openBetsBalance) - creditLimit).toStringEx("#.00");
            break;
        default:
            break;
    }
}

UserInfo.prototype.toUserFormatedCurrencyString = function (amount)
{
    if (typeof(amount) === "string")
    {
        amount = amount.replace(' ', '');
    }

    var parsedAmount = parseFloat(amount);
    if (isNaN(parsedAmount))
    {
        return "";
    }
    return this.currencyStringFormat.toCurrencyFormat(amount, this.currencyCode);
}

UserInfo.prototype.toUserLocalizedFormatedCurrencyString = function (amount) {
	if (typeof (amount) === "string") {
		amount = amount.replace(' ', '');
	}

	var parsedAmount = parseFloat(amount);
	if (isNaN(parsedAmount)) {
		return "";
	}
	return this.currencyStringFormat.toCurrencyLocalizedFormat(amount, this.currencyCode, NumberLocale);
};

UserInfo.prototype.updateData = function (data)
{
    this.userID = data[0];
    this.userName = this.getUserName(data);
    this.firstName = data[1];

    this.currencyId = +data[8];
    this.currencyCode = data[9];
    this.currencyStringFormat = data[10];

    this.updateBalance(data[3]);
    this.updateBalanceData({
        OpenBetsBalanceCustomerCurrency: data[7],
        SportsTotalBalance: data[3],
        CasinoBalanceCustomerCurrency: data[5],
        TotalBalanceCustomerCurrency: data[19],
        AdditionalBalances: data[39]
    });
    this.FreeBets = data[12].length ? this.parseFreeBets(data[12]) : [];
    this.IsLinked = !!data[13];
    this.IsCashOutAllowed = !!data[14];
    this.CashOutFee = data[15];
    this.LoginName = data[16];
    this.setAdditionalBalances(data);
    this.IsSelfExcluded = data[20];
    this.SelfExclusionExpireDate = data[21];
    this.IsTimeouted = data[22];
    this.TimeoutFacilityExpireDate = data[23];
    this.MerchCustomerCode = data[24];
    this.PIN = data[25];
    this.LastName = data[27];
    this.Email = data[28];
    this.entwineBalance = 0;
    this.entwineBalanceString = this.toUserFormatedCurrencyString(this.entwineBalance);
    this.RegistrationDate = data[33];
    this.IsExternalyVerified = data[34];
    UserInfo.setAcceptChangingOdds(data[35]);
    this.IsPlacingBetsDisabled = data[36];
    this.dispatchIsPlacingBetsDisabledChanged(data[36]);
    this.IsAccountVerified = data[37];
    this.CountryOfBirth = data[38] ? data[38] : undefined;
    this.IsIdVerificationPeriodFailed = data[40];
    this.GeoVerificationData = data[41];
    this.IsIdVerified = data[42];
    this.AllowPlacingBet = data[43];
    this.CountryOfRegistration = data[44];
    this.OddsStyleId = data[45];
    this.FreeSpinsCount = data[46];
    this.TaxInfo = data[29] || UserInfo.getCountryTaxState();

    if (typeof(isEntWineEnabled) !== "undefined" && isEntWineEnabled)
    {
        UserInfo.GetEntWineBalance();
    }
    if (data.length >= 31 && data[30])
    {
        CryptoHelper.setConfig({
            key: data[30],
            iv: this.userID
        });
    }

    var balanceConfig = BalanceConfig.NONE;
    if (data.length > 18) {
        balanceConfig = data[18] * 1;
    }
    var creditLimit = data.length > 17 ? data[17] * 1 : 0;
    var balanceAvailableOnLogin = data.length > 32 && data[32];

    this.getAdditionalCustomerData(balanceAvailableOnLogin, balanceConfig, creditLimit);
}

UserInfo.updateOpenBetsData = function (throwOnGetBalance) {
    UserInfoPageMethods.getUserOpenBetsData(function (data) {
        UserInfo.current && UserInfo.current.updateOpenBetsDataHandler(data, throwOnGetBalance);
    });
}

UserInfo.prototype.updateOpenBetsDataHandler = function (data, throwOnGetBalance)
{
    if (data && UserInfo.current)
    {
        data = JSON.parse(data);

        this.updateOpenBets(
            {
                GetCustomerOpenBetsCountEx: data[0],
                OpenFreeBetsBalanceCustomerCurrency: data[1]
            });
        this.openBetsCallFinished = true;
        if (this.isBalancesinitiated())
        {
            executeEvents(UserInfo.onGetBalance);
        }
        executeEvents(UserInfo.onDataUpdated);
    }
}

UserInfo.prototype.getUserName = function (data)
{
    return data[1] + " " + data[2];
}

UserInfo.prototype.getUserName = function (data)
{
    return data[1] + " " + data[2];
}

UserInfo.prototype.getBalance = function()
{
    return !isCasinoWalletEnabled && this.CreditIsEnabled ? this.AvailableFundsCustomerCurrency : this.balance;
}

UserInfo.prototype.getBalanceString = function()
{
    return this.toUserFormatedCurrencyString(this.getBalance());
}

UserInfo.prototype.getUserName = function (data)
{
    return data[1] + " " + data[2];
}

UserInfo.prototype.updateSeamlessData = function (data)
{
    this.userName = "";
    this.firstName = "";

    this.OpenBetsCount = 0;

    var opneBetsBlanace = 0;

    this.currencyId = "";
    this.currencyCode = "";
    this.currencyStringFormat = "{0} {1}";
    this.openedBetsBalanceString = "";
    this.openFreeBetsBalanceString = "";
    this.openBalanceString = "";
    var sportBalance = data.balance;
    this.sportsbookTotalBalanceString = data.balance;
    this.casinoTotalBalanceString = "";

    this.FreeBets = [];
    this.IsLinked = "";
    this.IsCashOutAllowed = "";
    this.CashOutFee = "";
}

UserInfo.prototype.updateBalance = function (_userBalanceString)
{
    // Get the seamless balance if available
    if (UserInfo.SeamlessCustomerBalance)
    {
        _userBalanceString = this.sanitizeSeamlessBalance(UserInfo.SeamlessCustomerBalance);
    }
    this.balance = this.getFormattedBalance(_userBalanceString);
    try
    {
        this.balance -= BetSlip.getLockedSumm();
    }
    catch (e) { }
    this.sportsbookTotalBalanceString = this.toUserFormatedCurrencyString(this.balance);
}

UserInfo.executeCommands = function (commands)
{
    if (!commands) return;

    for (var k in commands)
    {
        executeEvents(UserInfo.onCommand, UserInfo.current, commands[k]);
    }
}

UserInfo.showMessage = function (message)
{
    displayError(message);
    executeEvents(UserInfo.onMessage, UserInfo.current, message);
}

UserInfo.logout = function ()
{
    if (!UserInfo.current)
    {
        localStorage.removeItem("TaxInfo");
        sessionStorage.removeItem("UserInfoFreeBets");
        executeEvents(UserInfo.onNotLoggedIn);
        return;
    }

    window.scrollTo(0, 0);

    PageMethods.Logout(
        function (result)
        {
            if (result == "OK")
            {
                UserInfo.current = null;
                document.body.classList.remove("loggedin");
                // First we remove the free bets from the session storage
                sessionStorage.removeItem("UserInfoFreeBets");
                localStorage.removeItem("TaxInfo");
                Cookies.remove("TaxInfo");
                Cookies.remove("extrnlssid");
                UserInfo.TaxProvider = typeof taxProvider !== "undefined" && taxProvider || EmptyTaxProvider;

                if (IsAPIDefined()) { APIUser().logout(); }

                // UserInfo.removeBalanceCookies();

                executeEvents(UserInfo.onLogout);
                executeEvents(UserInfo.onAfterLogout);

                if (!IsSeamlessOrWallet) {
                    ApplicationHistory.push("/");
                    setTimeout(function () { 
                        window.location.reload()
                    }, 0);
                } else {
                    Application && Application.goHome();
                }
            }
            else
            {
                UserInfo.showMessage($string("General").ServerError);
            }
        },
        function () { }
    );
}

UserInfo.login = function (name, pass, remember, captchaLoginAllowed, captcha)
{
    if (UserInfo.current) return;
    if ((UserInfo.Tries > 2) && (captchaLoginAllowed))
    {
        UserInfo.logout();
        executeEvents(UserInfo.onCaptcha);
    }

    UserInfo.Tries++;

    if (IsAPIDefined())
    {
        if (captchaLoginAllowed && captcha)
        {
            APIUser().mobileLoginC(name, pass, captcha, UserInfo.afterLogin, UserInfo.onLoginFailed);
        }
        else
        {
            APIUser().mobileLogin(name, pass, UserInfo.afterLogin, UserInfo.onLoginFailed);
        }
    }
}

UserInfo.prototype.getUserName = function (data)
{
    return data[1] + " " + data[2];
}

UserInfo.jwtLogin = function (token, remember, captchaLoginAllowed, captcha) {
    if (UserInfo.current) return;

	UserInfo.Tries++;
    APIUser().jwtLogin(token, UserInfo.afterLogin, UserInfo.onLoginFailed);
}

UserInfo.danishNemIdLogin = function (response) {
    if (UserInfo.current) return;

    whl.doLogin(response, UserInfo.afterLogin);
}

UserInfo.afterLogin = function (res)
{
    if (res.status.toLowerCase() == "success")
    {
        // Set balance for seamless:
        if (res.balance && res.balance != "-1")
        {
            UserInfo.SeamlessCustomerBalance = res.balance;
            if (UserInfo.current)
            {   //update seamless balance
                UserInfo.current.updateBalance(UserInfo.SeamlessCustomerBalance);
                if (UserInfo.onUpdateBalance) { executeEvents(UserInfo.onUpdateBalance); }
            }
        }

        if (res.token)
        {
            setTimeout(function () { UserInfo.tokenLogin(res); }, 10);
        }
        else
        {
            UserInfo.executeLogin = true;
            // UserInfo.setBalanceCookies(0);
            UserInfo.updateData(res);
            UserInfo.GTMLoginSuccess();
            if (res[45] !== null && res[45] !== undefined)
            {
                Data.setOddStyleGlobal(res[45]);
            }
            executeEvents(UserInfo.onLoginSucceed);            
        }
    }
    else if (res.status.toLowerCase() == "twostep")
    {
        executeEvents(UserInfo.onTwoStepLogin, UserInfo.current, res.token);
    }
    else
    {   //error
        var nextGenLoginPopup;
        UserInfo.logout();
        executeEvents(UserInfo.onLoginFailed, this, res);
        if (res.message)
        {
            nextGenLoginPopup = document.getElementById('NextGenBetslipMobileForm');
            if (nextGenLoginPopup && nextGenLoginPopup.classList.contains('NextGenBetslipMobileForm'))
            {
                nextGenLoginPopup.innerHTML = '';
            }
            UserInfo.showMessage(res.message);
        }
    }
};

// serializes UserInfo FreeBets
UserInfo.serializeFreeBets = function ()
{
    if (!(UserInfo.current && UserInfo.current.FreeBets && Array.getLength(UserInfo.current.FreeBets) > 0))
    {
        return [];
    }

    var state = [], i,
        freeBets = UserInfo.current.FreeBets;

    for (i in freeBets)
    {
        state.push(freeBets[i].serialize());
    }

    return state;
};

// deserializes UserInfo FreeBets
UserInfo.deserializeFreeBets = function (freeBets)
{
    if (!freeBets) { return []; }
    
    var result = [], i;

    for (i in freeBets)
    {
        if (!freeBets[i]) { continue; }

        result.push(new BonusInfo(freeBets[i]));
    }

    return result;
};

// saves UserInfo FreeBets in session storage
UserInfo.saveFreeBetsState = function ()
{
    if (!WebStorage.isSupported()) { return; }

    var freeBets = UserInfo.serializeFreeBets();
    StorageUtils.saveToStorage("UserInfoFreeBets", JSON.stringify({ FreeBets: freeBets }), sessionStorage);
};

UserInfo.saveCountryTaxState = function (taxInfo)
{
    if (!WebStorage.isSupported() || !taxInfo) { return; }

    StorageUtils.saveToStorage("TaxInfo", JSON.stringify(taxInfo), localStorage);
   
};

UserInfo.getCountryTaxState = function ()
{
    if (!WebStorage.isSupported()) { return; }

    var taxInfo = localStorage.getItem("TaxInfo");

    if (!taxInfo && Cookies.get("TaxInfo"))
    {
        // new user registration cookies
        taxInfo = JSON.parse(Cookies.get("TaxInfo")).TaxInfo;
        return taxInfo;
    }
    return JSON.parse(taxInfo);
}

UserInfo.GTMLoginSuccess = function () {
    function retry() {
        setTimeout(UserInfo.GTMLoginSuccess, 5000);
    };

    if (UserInfo.current && UserInfo.current.isBalancesinitiated()) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'login',
            loginItems: {
                category: 'login',
                action: 'success',
                timestamp: serverdate,
                attempt: UserInfo.Tries
            },
            user: UserInfo.current
        });

        UserInfo.Tries = 0;
    }
    else {
        retry();
    }
}

UserInfo.GTMLoginFailed = function (errorMsg) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: 'login',
        loginItems: {
            category: 'login',
            action: 'failed',
            attempt: UserInfo.Tries,
            error: errorMsg,
            timestamp: serverdate
        }
    });
}

// returns UserInfo FreeBets from session storages
UserInfo.getFreeBetsFromStorage = function ()
{
    if (!WebStorage.isSupported()) { return []; }

    var sdata = sessionStorage.getItem("UserInfoFreeBets");
    if (!sdata) { return []; }

    var data = JSON.parse(sdata);
    if (!data) { return []; }

    return UserInfo.deserializeFreeBets(data.FreeBets);
};

UserInfo.RestartUpdateBalanceTimer = function ()
{
    if (UserInfo.BalanceUpdater.timer)
    {
        UserInfo.BalanceUpdater.restart();
    }
};

UserInfo.GetEntWineBalance = function () {
    UserInfoPageMethods.getEntWineBalance(function (res) {
        this.entwineBalance = res;
        this.entwineBalanceString = UserInfo.current.currencyStringFormat.toCurrencyFormat(this.entwineBalance, UserInfo.current.currencyCode);
        setValueOfHtmlElement('entwine_balance', this.entwineBalanceString);
    })
}

UserInfo.GetUserLimitationsInformation = function () {
    if (!UserInfo.current) {
        return;
    }
    UserInfoPageMethods.GetUserLimitationsInformation(
        function (result) {
            var res = JSON.parse(result);
            UserInfo.current.HasUserReachedHisTimeLimit = res.HasUserReachedHisLimits;
            UserInfo.current.HasUserConfirmedHisLimits = res.HasUserConfirmedHisLimits;
            UserInfo.current.UserProfileActivationDate = res.UserProfileActivationDate;

            executeEvents(UserInfo.onDataUpdated);
        });
}

UserInfo.checkSelfExclusion = function() {
    UserInfoPageMethods.CheckSelfExclusion(
        function (result)
        {
            var isExcluded = JSON.parse(result);
            if (isExcluded)
            {
                if (UserInfo.current) { UserInfo.showMessage($string("Login").AccountRestricted); }
                UserInfo.logout();
            }
        });
}

UserInfo.getMobileLobbyURL = function ($elem)
{
    'use strict';

    if (!$elem || APIUser().getMobileLobbyURL === undefined)
    {
        return false;
    }

    $elem.attr('href', APIUser().getMobileLobbyURL());

    return false;
};

UserInfo.getMobileBankURL = function ($elem)
{
    'use strict';

    if (!$elem || APIUser().getMobileBankURL === undefined)
    {
        return false;
    }

    $elem.attr('href', APIUser().getMobileBankURL());

    return false;
};

UserInfo.RecursiveUpdater = (function () {
    function RecursiveUpdater (method, interval)
    {
        this.timer = 0;
        this.interval = interval;
        this.method = method;
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.restart = this.restart.bind(this);
        this.update = this.update.bind(this);
    };
    
    RecursiveUpdater.prototype.start = function () 
    {
        this.timer = setTimeout(this.update, this.interval);
    };

    RecursiveUpdater.prototype.stop = function () 
    {
        clearTimeout(this.timer);
    };

    RecursiveUpdater.prototype.restart = function () 
    {
        this.stop();
        this.start();
    };

    RecursiveUpdater.prototype.update = function () 
    {
        this.method();
        this.start();
    }

    return RecursiveUpdater;
})();

typeof extDict !== "undefined" && extDict['/JSComponents/Data/UserInfo.ext.js']();

window.addEventListener("load", function ()
{
    setTimeout(function () 
    {
        UserInfo.BalanceUpdater = new UserInfo.RecursiveUpdater(UserInfo.updateBalance, BalanceUpdateTimeout);
        UserInfo.SelfExclusionUpdater = new UserInfo.RecursiveUpdater(UserInfo.checkSelfExclusion, UserInfo.selfExclusionCheckInterval);
        UserInfo.ExtSessionUpdater = new UserInfo.RecursiveUpdater(UserInfo.updateExtSession, RefreshExternalSessionTimeout);
        UserInfo.CheckSessionUpdater = new UserInfo.RecursiveUpdater(UserInfo.checkSession, UserInfo.CheckSessionInterval);

        UserInfo.GetUserLimitationsInformation();
        UserInfo.updateBalance();
        UserInfo.BalanceUpdater.start();
        UserInfo.SelfExclusionUpdater.start();

        if (IsAPIDefined())
        {
            UserInfo.tryObtainExternalLogin();
            if (typeof(RefreshExternalSessionTimeout) !== "undefined") {
                UserInfo.ExtSessionUpdater.start();
            }
        }

        if (typeof InactivityLogoutMinutes !== "undefined" && InactivityLogoutMinutes > 0) {
            UserInfo.CheckSessionUpdater.start();
        }
    }, 0);
});

window.addEventListener("load", function() 
{    
    if (UserInfo.TaxProvider !== EmptyTaxProvider) 
    {
        UserInfo.saveCountryTaxState(UserInfo.TaxProvider.TaxInfo);
    }
});
